<template>
  <div class="resultPageBus">
    <!-- <div class="resultPageBus__loading" v-if="isPageLoading">
      <adx-loading-primary/>
    </div> -->
    <div class="resultPageBus__background">
    </div>
    <div class="resultPageBus__wrapper">
      <div class="resultPageBus__topbackground">
      </div>
      <div class="resultPageBus__top">
        <div class="resultPageBus__top__header">
          <div class="resultPageBus__top__header__search">
            <i class="adx-ic_search"></i>
            <input v-model="searchValue" type="text" placeholder="Search" class="subhead">
          </div>
        </div>
        <div class="resultPageBus__top__filter">
          <div class="resultPageBus__top__filter__left">
            <template>
              <adx-dropdown-checkbox :list="categoryOptions" @selected="selectedCategory"
                labelButton="Category" :title="`Category`" :default="selectedCategoryValue"
                :loading="isLoadingFilter"
                :color="'pink'"/>
              <adx-dropdown-checkbox :list="POTypeOptions" @selected="selectedPO"
                labelButton="PO Name" :title="`PO Name`" :default="selectedPOValue"
                :loading="isLoadingFilter"
                :color="'pink'"/>
              <adx-dropdown-multiple :list="multipleOptions" @apply="applyMoreFilter"
                :title="`More Filters`"
                :loading="isLoadingFilter"
                :color="'pink'" 
                :isReset="isResetMultiDropdown" />
            </template>
            <div class="resultPageBus__top__filter__left__sort--mobile">
              <adx-dropdown-list class="sort-mobile" @selected="selectedSort" :list="sortOptions" labelButton="Sort by" :title="`Sort by`" :color="'pink'" />
            </div>
            <div v-if="filtered" class="reset">
              <button class="btn-regular link" @click="resetFilter">Reset</button>
            </div>
            </div>
            <div class="resultPageBus__top__filter__right">
            <span class="subhead">Sort by :</span>
            <div>
              <adx-dropdown-select :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sortOptions" />
            </div>
          </div>
        </div>
      </div>
      <div class="resultPageBus__bottom">
        <adx-loading-primary class="loading-content" v-if="isPageLoading"/>
        <div v-else class="resultPageBus__bottom__content">
          <div class="resultPageBus__bottom__content__listings" ref="listing">
            <template>
            <adx-list-result v-if="totalListing" :data='itemsCategory'
              @goToParentDetail="goToLocationDetail" @previewImage="itemPreview" @addToCampaign="addToOrder"
              :isAction="true" :viewPhotos="true"
              :buttonSaved="false"
              :tagPhotos="true"
              >
              <div class="expandableParent" :slot="['topcontent', index].join('-')" v-for="(item,index) in itemsCategory" :key="'custom_'+index">
                <div class="expandableParent__image">
                  <img v-if="item.image" :src="item.image"/>
                  <img v-else :src="`/img/notfound/img-placeholder_landscape.jpg`" alt="">
                </div>
                <div class="expandableParent__route">
                  <div class="color-grey micro-font"> ROUTE </div>
                  <div class="regular-font strong elipsis">{{item.title}}</div>
                </div>
                <div class="expandableParent__bustype">
                  <div class="color-grey micro-font"> CATEGORY </div>
                  <div class="regular-font elipsis">{{item.category}}</div>
                </div>
                <div class="expandableParent__trip">
                  <div class="color-grey micro-font"> EST. TRIP </div>
                  <div class="regular-font">{{item.trip}}</div>
                </div>
                <div class="expandableParent__distance">
                  <div class="color-grey micro-font"> TRIP DISTANCE </div>
                  <div class="regular-font"> {{item.distance}}</div>
                </div>
              </div>  
              <template slot="loading" v-if="!isLoading">
                <div v-if="next" class="resultPageBus__bottom__content__listings__paging" @click.stop="loadInfiniteData">
                  <button class="btn-regular secondary"> <strong>Load More</strong> </button>
                </div>
                <div v-else class="resultPageBus__bottom__content__listings__paging">
                  <span class="resultPageBus__bottom__content__listings__paging__empty"> There is no more data </span>
                </div>
              </template>
              <template slot="loading" v-else>
                <div class="resultPageBus__bottom__content__listings__load-more">
                  <adx-loading-primary v-if="isLoading" />
                </div>
              </template>
            </adx-list-result>
            <adx-empty-selection class="empty-content" v-else-if="totalListing == 0"/>
            </template>
          </div>
          <div class="resultPageBus__bottom__content__wrapper" ref="orderSummaryWrapper">
            <div class="resultPageBus__bottom__content__wrapper__orderSummary" :class="[scrollStatus?'sticky':'']" :style="{ 'width': orderSummaryWidth + 'px' }" v-if="!isPageLoading" ref="orderSummary">
              <div class="resultPageBus__bottom__content__wrapper__orderSummary__header">
                Order Summary
              </div>
              <div class="resultPageBus__bottom__content__wrapper__orderSummary__content">
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__period">
                  <adx-dropdown-select id="campaign-period" :label="`Period of Campaign`" :value.sync='selectedPeriod' :options="periodOptions" :key="selectedPeriod"/>
                </div>
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__period">
                  <div class="calendar">
                    <v-date-picker
                      v-model='startDate'
                      :popoverVisibility="popoverVisibility"
                      :min-date='nextweek'
                      :theme-styles='themeStyles'
                      class='date-picker'>
                      <div class="field"
                        slot-scope='{ inputValue, updateValue }'
                      >
                      <div class="start_date">
                        <label class="mini-font calendar-label">Start Date</label>
                        <input
                          class="date-picker-input"
                          type='text'
                          required
                          readonly
                          :value='inputValue'
                          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                      </div>
                      <div class="arrow">
                      <i class="icon-arrow-forward"></i>
                      </div>
                      <div class="end_date">
                        <label class="mini-font calendar-label">End Date</label>
                        <input
                          class="date-picker-input color-grey"
                          placeholder="DD/MM/YY"
                          type='text'
                          required
                          readonly
                          :value='endDatePackage'
                          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      </div>
                      </div>
                    </v-date-picker>
                  </div>
                </div>
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items" v-if="selectedOrders.length>0">
                  <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items__text">
                    <span class="subhead strong">Selected Advertisement</span>
                  </div>
                  <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items__item" v-for="(item, index) in selectedOrders" :key="index">
                    <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items__item__left">
                      <i class="icon-deleted" @click="deleteOrder(index)"></i>
                      <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items__item__left__body">
                        <h6 class="color-grey mini-font to-uppercase">{{item.category}}</h6>
                        <h6 class="subhead strong">{{item.title}}</h6>
                        <h6 class="color-grey subhead">{{item.media_name}}</h6>
                        <div class="numOfBus">
                          <adx-dropdown-select :size="`small`" :options="sumOrderOptions" :value.sync="item.count" :selected="selectedNumber(item)" />
                        </div>
                      </div>
                    </div>
                    <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__items__item__right">
                      <span class="color-pink subhead strong">{{getItemPrice(item.price * item.count) | formatMoney}}</span>
                    </div>
                  </div>
                </div>
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__content__empty" v-else>
                  <span class="resultPageBus__bottom__content__wrapper__orderSummary__content__empty__text"> 
                    Please select at least one advertisement to add an order 
                  </span>
                </div>
              </div>
              <div class="resultPageBus__bottom__content__wrapper__orderSummary__footer" v-if="selectedOrders.length>0">
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__footer__ppn">
                  <h2 class="subhead">PPN 10%</h2>
                  <h2 class="price color-pink subhead">{{(0.1 * getTotal()) | formatMoney}}</h2>
                </div>
                <div class="resultPageBus__bottom__content__wrapper__orderSummary__footer__total">
                  <h2 class="subhead">Total Order</h2>
                  <h1 class="price large-font color-pink">{{getTotalByPPN() | formatMoney}}</h1>
                </div>
              </div>
              <div class="resultPageBus__bottom__content__wrapper__orderSummary__footer">
                <button v-if="!id" class="btn-large primary continue" :disabled="selectedOrders.length<1 || isLoadingContinue" @click="addCampaign"> 
                  Continue <adx-loading-secondary v-if="isLoadingContinue"/> 
                </button>
                <button v-else class="btn-large primary continue" :disabled="selectedOrders.length<1 || isLoadingContinue" @click="editCampaign"> 
                  Continue <adx-loading-secondary v-if="isLoadingContinue"/> 
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="resultPageBus__modalMobile">
      <adx-modal v-if="isShowOrderMobile" :hide-close="true">
        <template slot="content">
        <div>
          <div class="resultPageBus__bottom__content__orderSummary--mobile" v-if="!isPageLoading">
            <div class="resultPageBus__bottom__content__orderSummary--mobile__close"><i class="icon-close" @click="toggleModalOrder"></i></div>
            <div class="resultPageBus__bottom__content__orderSummary--mobile__header smedium strong">
              Order Summary
            </div>
            <div class="resultPageBus__bottom__content__orderSummary--mobile__content">
              <div class="resultPageBus__bottom__content__orderSummary--mobile__content__period">
                <adx-dropdown-select id="campaign-period" :label="`Period of Campaign`" :value.sync='selectedPeriod' :options="periodOptions" :key="selectedPeriod"/>
              </div>
               <div class="resultPageBus__bottom__content__orderSummary--mobile__content__period">
                <div class="calendar">
                    <v-date-picker
                      v-model='startDate'
                      :popoverVisibility="popoverVisibility"
                      :min-date='nextweek'
                      :theme-styles='themeStyles'
                      class='date-picker'>
                      <div class="field"
                        slot-scope='{ inputValue, updateValue }'
                      >
                      <div class="start_date">
                        <label class="mini-font calendar-label">Start Date</label>
                        <input
                          class="date-picker-input"
                          type='text'
                          required
                          readonly
                          :value='inputValue'
                          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                      </div>
                      <div class="arrow">
                      <i class="icon-arrow-forward"></i>
                      </div>
                      <div class="end_date">
                        <label class="mini-font calendar-label">End Date</label>
                        <input
                          class="date-picker-input color-grey"
                          placeholder="DD/MM/YY"
                          type='text'
                          required
                          readonly
                          :value='endDatePackage'
                          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      </div>
                      </div>
                    </v-date-picker>
                  </div>
                </div>
            </div>
            <div class="resultPageBus__bottom__content__orderSummary--mobile__content__wrapper" v-if="selectedOrders.length > 0">
                <div class="resultPageBus__bottom__content__wrapper__orderSummary--mobile__content__items__text">
                  <span class="subhead strong">Selected Advertisement</span>
                </div>
              <div class="resultPageBus__bottom__content__orderSummary--mobile__content__items">
                <div class="resultPageBus__bottom__content__orderSummary--mobile__content__items__item" v-for="(item, index) in selectedOrders" :key="index">
                  <div class="resultPageBus__bottom__content__orderSummary--mobile__content__items__item__left">
                    <i class="icon-deleted" @click="deleteOrder(index)"></i>
                    <div class="resultPageBus__bottom__content__orderSummary--mobile__content__items__item__left__body">
                      <h6 class="color-grey mini-font to-uppercase">{{item.category}}</h6>
                      <h6 class="subhead strong">{{item.title}}</h6>
                      <h6 class="color-grey subhead">{{item.media_name}}</h6>
                      <div class="numOfBus">
                        <adx-dropdown-select :size="`small`" :options="sumOrderOptions" :value.sync="item.count" :selected="selectedNumber(item)" />
                      </div>
                    </div>
                  </div>
                  <div>
                    <span class="resultPageBus__bottom__content__orderSummary--mobile__content__items__item__right color-pink subhead strong"> 
                      {{getItemPrice(item.price * item.count) | formatMoney}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="resultPageBus__bottom__content__orderSummary--mobile__footer" v-if="selectedOrders.length>0">
              <div class="resultPageBus__bottom__content__orderSummary--mobile__footer__ppn">
                <h2 class="subhead">PPN 10%</h2>
                <h2 class="price color-pink subhead">{{(0.1 * getTotal()) | formatMoney}}</h2>
              </div>
              <div class="resultPageBus__bottom__content__orderSummary--mobile__footer__total">
                <h2 class="subhead">Total Order</h2>
                <h1 class="large-font color-pink">{{getTotalByPPN() | formatMoney}}</h1>
              </div>
              </div>
            </div>
            <div class="resultPageBus__bottom__content__orderSummary--mobile__content" v-else>
              <span class="resultPageBus__bottom__content__orderSummary--mobile__content__empty color-grey mini-font"> 
                Please select at least one advertisement to add an order 
              </span>
            </div>
          </div>
          <div class="resultPageBus__bottom__content__orderSummary--mobile__footerContinue">
            <button v-if="!id" class="btn-large primary continue" :disabled="selectedOrders.length<1 || isLoadingContinue" @click="addCampaign"> 
              Continue <adx-loading-secondary v-if="isLoadingContinue"/>
            </button>
            <button v-else class="btn-large primary continue" :disabled="selectedOrders.length<1 || isLoadingContinue" @click="editCampaign"> 
              Continue <adx-loading-secondary v-if="isLoadingContinue"/>
            </button>
          </div>
        </div>
        </template>
      </adx-modal>
      </div>
    </div>
    <div class="resultPageBus__orderFooter">
      <button class="btn-large primary continue" @click="toggleModalOrder"> 
        <span class="subhead strong">
          View Order 
        </span>
        <span class="subhead" v-if="sumOrder>1">
          {{sumOrder}} Items
        </span>
        <span class="subhead" v-else>
          {{sumOrder}} Item
        </span>
        <span class="subhead">
          {{getTotalByPPN() | formatMoney}}
        </span>
      </button>
    </div>
    <!-- modal image in advertisment item -->
    <adx-modal v-if="isPreview" @modal-close="togglePreviewImage" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="regularPhoto"/>
        <div class="modal__wrapper__footer">
          <!-- <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{busDetail.title}}</span> -->
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import CollectionSlider from '@/components/Slider/CardSlider'
import DetailSlider from '@/components/Slider/DetailSlider'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdownCustom'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownMultiple from '@/components/Dropdown/MultipleDropdown'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownSelect from '@/components/Form/SelectDropdown'
import EmptySelection from '@/components/NotFound/Selection'
import ExpandableResult from '@/components/ExpandableListItems/CustomExpandableList'
import InfiniteLoading from 'vue-infinite-loading'
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import Modal from '@/components/Modal'

import moment from 'moment'
import api from '@/api'
import types from '@/lib/types'
import { apiV2} from '@/api/urls'
import { restEdge } from '@/api/edgeUrls'
import { fromKeys, mapListFilter } from '@/lib/transformer'
import { discoveryParams } from '@/api/params'
import { mapGetters } from 'vuex'
import { formatShortDate } from '@/lib/util'
import * as validationLib from '@/lib/validation/'
import { formatNumber } from '@/lib/filter'
const { helpers } = validationLib

export default {
  name: 'adx-resultpage-bus',
  components: {
    'adx-collection-slider': CollectionSlider,
    'adx-detail-slider': DetailSlider,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-multiple': DropdownMultiple,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-select': DropdownSelect,
    'adx-empty-selection': EmptySelection,
    'adx-list-result': ExpandableResult,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-secondary': LoadingSecondary,
    'adx-modal': Modal,
    'infinite-loading': InfiniteLoading,
  },
  props: {

  },
  data() {
    return {
      id: null,
      count: null,
      endDate: null,
      items: [],
      isLoading: false,
      isLoadingContinue: false,
      isLoadingFilter: false,
      isPreview: false,
      isResetMultiDropdown: false,
      isShowOrderMobile: false,
      isPageLoading: false,
      isInfiniteLoad: false,
      itemsCategory: ``,
      labelType: 'Sort',
      next: null,
      orderSummaryWidth: 0,
      page: 1,
      popoverVisibility: 'focus',
      query: '',
      regularPhoto:[],
      scrollStatus:false,
      searchValue: ``,
      searchBoxValue: null,
      selectedOrders: [],
      selectedPeriod: 1,
      selectedPOValue: [],
      selectedCategoryValue: [],
      selectedBusTypeValue: [],
      selectedMinDistance: null,
      selectedMaxDistance: null,
      selectedSortValue: `-impression`,
      startDate: null,
      status: ``,
      sumOrderOptions:[],
      title: '',
      totalListing: 0,
      user: {
        admin : null
      },
      periodOptions: [],
      POTypeOptions: [],
      categoryOptions: [],
      multipleOptions: [],
      sortOptions: [
        {
          id: 0,
          label: `Highest Impressions`,
          value: `-impression`
        },
        {
          id: 1,
          label: `Name `,
          value: `name`
        },
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
    }
  },
  computed: {
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort' && key !== 'search' &&  key !== 'page' &&
        key !== 'query' &&
        querys[key]) filtered = true
      });
      return filtered
    },
    endDatePackage: function(){
      var end = new Date(this.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + this.selectedPeriod);
      return formatShortDate(end)
    },
    getFilterParams: function () {
      let tempminDistance = null

      tempminDistance = this.selectedMaxDistance ? this.selectedMinDistance : undefined
      const params = {
        page: this.page,
        search: this.searchValue ? this.searchValue : undefined,
        sort: this.selectedSortValue || undefined,
        brand: this.selectedPOValue.join(`,`) || undefined,
        category: this.selectedCategoryValue.join(',') || undefined,
        busType: this.selectedBusTypeValue.join(',') || undefined,
        minDistance: this.selectedMinDistance == null? undefined : this.selectedMinDistance,
        maxDistance: this.selectedMaxDistance || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
    ...mapGetters ({
      token: 'token',
      account: 'account',
      userId: 'userId',
    }),
    sumOrder: function() {
      return this.selectedOrders.length
    },
    minimumPeriod: function(){
      return this.selectedOrders.length > 0 ? Math.max(...this.selectedOrders.map(item => parseInt(item.constraint.minPeriod))) : 1
    },
    getAllOrderData: function() {
      const data = {
        selectedOrders: this.selectedOrders || [],
        startDate: Date(this.startDate) || this.nextweek,
        selectedPeriod: this.selectedPeriod || this.minimumPeriod
      }
      return data
    }
  },
  watch: {
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.page = 1
        this.loadListing()
      });
    },
    searchValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.page = 1
        this.loadListing()
      });
    }, 500),
    selectedPeriod: function(newValue) {
      this.$nextTick(() => {
        if (newValue < this.minimumPeriod) {
          this.showErrorNotification(`Minimum period is ${this.minimumPeriod}`)
          // Force set to minimum period
          this.selectedPeriod = this.minimumPeriod
        }
        //update data in local storage
        this.saveToLocal()
      });
    },
    startDate: function(newValue, oldValue){
      if(!newValue || newValue == oldValue) {
        this.startDate = oldValue
        this.popoverVisibility = 'hidden'
        this.$nextTick(() => this.popoverVisibility = 'focus')
      }
      //update data in local storage
      this.saveToLocal()
    }
  },
  beforeCreate() {

  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleWindowZoom);
    this.id = this.$route.params.id
  },
  async beforeMount() {
    let savedOrder = await this.getFromLocal()
    this.selectedOrders = await savedOrder.selectedOrders || []
    this.selectedPeriod = await savedOrder.selectedPeriod || this.minimumPeriod
    let date = await savedOrder.selectedStart || this.nextweek

    this.startDate = new Date(date)
  },
  async mounted() {
    const query = this.$route.query 
    this.user.admin = this.account.isStaff
    if (!this.token) {
      this.id = null
      this.$router.replace({
        params: {
          id: undefined
        }
      })
    }
    this.getPeriod()
    this.getSumBus()
    this.setSummaryWidth()
    await this.getFilter()
    await this.loadListing()
  },
  beforeUpdate() {

  },
  updated() {
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setSummaryWidth);
  },
  methods: {
    setSummaryWidth(){
      let wrapper = this.$refs.orderSummaryWrapper
      let orderSummary = this.$refs.orderSummary
      if(wrapper){
        let widthWrapper = wrapper.offsetWidth
        this.orderSummaryWidth = widthWrapper
        orderSummary.style.width = widthWrapper + 'px'
      }
    },
    handleScroll() {
      let listing = this.$refs.listing
      let doc = document.documentElement;
      let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0) - 100;
      let ref = listing? listing.offsetTop: 0

      this.scrollStatus  = ref < top
    },
    getFilter () {
      this.isPageLoading = true;
      (async () => {
        this.isLoadingFilter = true
        // Get bus related filters (category, bus type)
        const response = await api.get(restEdge.busDiscoveryResultFilter, {useRestEdge: true, })
        if (response.status === 200) {
          // Category options
          this.categoryOptions = mapListFilter({ obj: response.data.categories, id: `id`, value: `id`, label: `title`})
          // Bus type options
          const option = {
            type: 'checkbox',
            title: 'Bus Type',
            list: mapListFilter({ obj: response.data.vehicles, id: `id`, value: `id`, label: `title`})
          }
          this.multipleOptions.push(option)
          // Distance oprions
          let tempDistance = response.data.maxDistance
          const distance = {
              type: 'minmax',
              title: 'Distance Range',
              minValue: 0,
              maxValue: tempDistance,
              minLabel: '0 Km',
              maxLabel:  tempDistance + 'Km'
          }
          this.multipleOptions.push(distance)
          // PO name options
          this.POTypeOptions = mapListFilter({ obj: response.data.brands, id: `id`, value: `id`, label: `title`})
          this.isLoadingFilter = false
        }
      })();
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()
        this.periodOptions = data.periods
      })();
    },
    async getSumBus() {
      let bus = [...Array(21).keys()].slice(1).map((el) => {
        return { label: `${el} Bus`,value: el }
      })
      this.sumOrderOptions = await bus
    },
    getTotal(){
      let total = 0
      this.selectedOrders.forEach(element => {
        let beforeTax = element.price * element.count * this.selectedPeriod 
        let afterTax = beforeTax / 1.1
        total += (element.include_tax? afterTax : beforeTax)
      });
      return total
    },
    getItemPrice(itemPrice){
      return itemPrice * this.selectedPeriod 
    },
    getTotalByPPN(){
      return this.getTotal() + (this.getTotal()*0.1)
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    },
    applyMoreFilter(result){
      // Category filter
      let busType = result.filter(obj => obj.title === 'Bus Type')[0]
      if (busType) {
        this.selectedBusTypeValue = busType.result
      }
      // Distance filter
      let distance = result.filter(obj => obj.title === 'Distance Range')[0]
      if (distance.result) {
        this.selectedMinDistance = distance.result.min
        this.selectedMaxDistance = distance.result.max
      } else {
        this.selectedMinDistance = null
        this.selectedMaxDistance = null
      }

      this.$nextTick(() => {
        this.isResetMultiDropdown = false
        this.page = 1
        this.loadListing()
      });
    },
    selectedNumber(item){
      let minQuantity = item.constraint.minQuantity
      if (item.count < minQuantity) {
        item.count = minQuantity
        this.showErrorNotification('Minimum quantity allowed for this campaign is ' + minQuantity)
      }
      // Update data in localStorage
      this.saveToLocal()
    },
    loadListing(isFromInfinite = false) {
      (async () => {
        if(!isFromInfinite) this.itemsCategory = []
        if(isFromInfinite){
          this.isLoading = true
        } else{
          this.isPageLoading = true
        }

        let params = {
          ...this.getFilterParams,
        }

        const { data, status, statusText } = await api.get(restEdge.busDiscoveryResult, {useRestEdge: true, params})

        if (status === 200) {
          this.count = data.count
          if (data.next) {
            this.next = data.next
          }else{
            this.next = false
          }
          this.$data.isLoading = false
          this.mapData(data.results, isFromInfinite)
        } else {
          this.showErrorNotification(statusText)
        }
      })();
    },
    mapData(data, isFromInfinite){
      let listing = []
      data.map((bus) => {
        let busInstance = {}
        busInstance.distance = bus.distance? formatNumber(bus.distance) + ' km' : '-'
        busInstance.id = bus.id
        busInstance.trip = bus.trip? formatNumber(bus.trip) + ' / day' : '-'
        busInstance.title = bus.title
        busInstance.brand = bus.brand? bus.brand.title : '-'
        busInstance.category = bus.category? bus.category.title : '-'
        let listFeatured = bus.contents.filter(x => x.is_featured == true).pop()
        busInstance.image = listFeatured? listFeatured.content_url : bus.contents.length > 0? bus.contents[0].content_url : null
        
        let media = []

        bus.buses.map(item => {
          let listFeaturedImage = item.contents.filter(x => x.is_featured == true).pop()
          let imagePlacement = listFeaturedImage? listFeaturedImage.content_url : item.contents.length > 0? item.contents[0].content_url : null

          let minPeriod = item.generic.minPeriod
          let minQuantity = item.generic.minQuantity
          let leadPreCampaign = item.generic.leadPreCampaign
          let desc = [
            "- " + item.generic.description,
            "- Minimum order " + minPeriod + " month(s)",
            "- Minimum quantity " + minQuantity + " unit(s)",
            "- Lead time " + leadPreCampaign + " day(s)",
            "- Bus type : " + item.vehicle.title,
          ]

          media.push(
            {
              id: item.id,
              seat: item.seats,
              placement: item.generic.title,
              description: desc,
              period: item.generic.pricingPlan,
              price: item.generic.price,
              include_tax: false,
              photo: item.contents,
              thumbnail: imagePlacement,
              constraint: {
                minPeriod: minPeriod,
                minQuantity: minQuantity,
                leadPreCampaign: leadPreCampaign,
              }
            }
          )
        })
        busInstance.media = media
        listing.push(busInstance)
      })
      if (isFromInfinite) {
        this.$data.itemsCategory = this.$data.itemsCategory.concat(listing)
      } else {
        this.$data.itemsCategory = listing
      }
      this.totalListing = this.$data.itemsCategory.length
      this.isPageLoading = false
    },
    async loadInfiniteData() {
      if (this.$data.next) {
        this.$data.isLoading = true
        this.$data.page += 1
        this.loadListing(true)
      }
    },
    selectedCategory(item){
      this.selectedCategoryValue = item
      this.$nextTick(() => {
        this.page = 1
        this.loadListing()
      });
    },
    selectedPO(item){
      this.selectedPOValue = item
      this.$nextTick(() => {
        this.page = 1
        this.loadListing()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `-impression`
      } else {
        this.selectedSortValue = item.value
      }
    },
    togglePreviewImage(){
      this.isPreview = !this.isPreview
    }, 
    setCalenderValue() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      this.startDate = nextweek
      var nextweekplus = new Date();
      nextweekplus.setDate(nextweekplus.getDate() + 8);
      this.endDate = nextweekplus
      this.endDate = this.endDatePackage
    },
    addToOrder(list, item){
      /* Order addition & deletion general idea:
        Before the page reloads (beforeMounted hooks), get order data from localStorage.
        Whenever order addition and deletion occur, local variable (selectedOrders) and localStorage will be both changed.
        Thus, both data will always be the same.
      */

      // List is route information. Item is placement (generics) information
      let price = item.include_tax? (item.price/1.1) : item.price
      let order = {
        location_id: list.id,
        item_id: item.id,
        title: list.title,
        price: price,
        category: list.category,
        media_name: item.placement,
        count: item.constraint.minQuantity,
        constraint: item.constraint
      }

      // Selected item ids
      const ordered = this.selectedOrders.map(x => {
        return x.item_id
      })

      // Handle new order addition and validation
      if (ordered.includes(order.item_id)){
        const y = this.selectedOrders.filter(x => {
          return x.item_id == item.id
        })

        if (y[0].count >= 20) {
          this.showErrorNotification(`Item failed added to your order.`)
        }else {
          this.showSuccessNotification(`Item successfully added to your order.`)
          y[0].count += 1
        }
      } else {
        this.showSuccessNotification(`Item successfully added to your order.`)
        this.selectedOrders.push(order)
      }

      // Set minimum period for the order and change period dropdown options
      if (this.selectedPeriod < this.minimumPeriod) {
        this.selectedPeriod = this.minimumPeriod
      }
      //update data in local storage
      this.saveToLocal()
    },
    toggleModalOrder() {
      this.isShowOrderMobile = !this.isShowOrderMobile
    },
    itemPreview(item){
      let tempPhotos = []
        if(item.photo.length > 0){
          item.photo.map( el =>{
            tempPhotos.push({
              caption: el.original,
              id: el.original,
              is_primary: false,
              thumbnail: el.content_url,
              url: el.content_url
            })
          })
        }
      this.regularPhoto = tempPhotos
      this.isPreview = !this.isPreview
    },
    addCampaign(){
      if (this.token) {
        this.isLoadingContinue = true
        let orders = []
        if (this.selectedOrders.length > 0 ) {
          this.selectedOrders.map(order => {
            orders.push({
              count: order.count,
              bus: parseInt(order.item_id)
            })
          })
        }
        let body = {
          campaignInfo: {
            title: "Untitled",
            start: moment(this.startDate).format('YYYY-MM-DD'),
            period: this.selectedPeriod,
            owner: this.userId
          },
          orderRoutes: orders
        };

        (async () => {
          const { data, status } = await api.post(restEdge.busDiscoveryAddCampaign, body, {useRestEdge: true, needToken: true})
          if(status == 200){
            let id = data.id
            this.isLoadingContinue = false
            this.resetLocalStorage()
            this.$router.push({path: `/bus/campaigneditor/${id}`})
          } else {
            this.showErrorNotification('Oops data can not be saved!')
            this.isLoadingContinue = false
          }
        })();
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }
      
    },
    editCampaign(){
      this.isLoadingContinue = true
      let orders = []
      if (this.selectedOrders.length > 0 ) {
        this.selectedOrders.map(order => {
          orders.push({
            count: order.count,
            bus: {
              id : parseInt(order.item_id)
            }
          })
        })
      }
      let body = {
        campaign_info: {
          start: moment(this.startDate).format('YYYY-MM-DD'),
          period: this.selectedPeriod,
        },
        order_routes: orders
      };

      (async () => {
        const { data, status } = await api.patch(restEdge.editBusCampaign(this.id), body, {useRestEdge: true, needToken: true})
        if(status == 200){
          this.isLoadingContinue = false
          this.resetLocalStorage()
          this.$router.push({ name: 'buscampaigneditor', param: { id: this.id } })
        } else {
          this.showErrorNotification('Oops data can not be saved!')
          this.isLoadingContinue = false
        }
      })();
    },
    deleteOrder(index){
      this.selectedOrders.splice( index, 1 );
      //update data to local storage
      this.saveToLocal()
    },
    showErrorNotification(message){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: message,
        type: 'danger'
      });
    },
    showSuccessNotification(message){
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: message,
        type: 'success'
      });
    },
    goToLocationDetail(list) {
      this.$router.push({name: 'detailpagebus', params: { id: list.id, campaignId : this.id}})
    },
    resetFilter() {
      this.selectedPOValue = []
      this.selectedCategoryValue = []
      this.selectedSortValue = '-impression'
      this.selectedBusTypeValue = []
      this.selectedMinDistance = null
      this.selectedMaxDistance = null
      this.isResetMultiDropdown = true

      const params = {
        brand: undefined,
        bustype: undefined,
        category: undefined,
        minDistance: undefined,
        maxDistance: undefined
      }
    },
    getFromLocal() {
      let savedData = localStorage.getItem('selectedBusOrder')
      if (!savedData) {
        savedData = JSON.stringify({
          selectedOrders: [],
          selectedPeriod: 1,
          selectedStart: this.nextweek
        })
      }
      return JSON.parse(savedData)
    },
    saveToLocal(data = null){
      let busData = null
      if (data) {
        busData = data
      } else {
        busData = JSON.stringify({...this.getAllOrderData})     
      }
      localStorage.setItem('selectedBusOrder', busData)
    },
    resetLocalStorage(){
      let busData = JSON.stringify({
        selectedOrders: [],
        selectedPeriod: 1,
        selectedStart: this.nextweek
      })
      this.saveToLocal(busData)
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.resultPageBus {
  .cardSlider {
    margin-left: -8px;
  }
  .modal__content{
    &.mini {
      width: 30%;
    }
  }
  .slick-slide img{
    img{
      width: 1080px;
      max-width: 100%;
    }
  }
  .icon-close:before {
    font-size: 25px;
    font-weight: bold;
  }
  .img-container{
    img{
      object-fit: contain;
      margin: 0px;
      max-height: 630px;
      max-width: 100%;
    }
  }
  .expandableList__card__channels__content__left__info {
    span {
      display: inline-block;
      white-space: pre-line;
    }
  }
}
.resultPageBus__bottom__content__wrapper__orderSummary__content {
  .date-picker-input{
    font-size: 15px;
  }
  .selectDropdown .select input {
    font-size: 15px;
  }

  &__period {
    .selectDropdown {
      .select__title {
        left: 8px;
      }
      .select input {
        padding-left: 8px;
      }
    }
  }
  &__items__item__left__body {
    .selectDropdown {
      font-size: 12px;
      width: 60%;
      .select__icon {
        right: 4px;
      }
      .popup {
        height: 150px;
        overflow: auto;
        width: max-content;
        .item {
          padding: 4px;
        }
      }
    }
  }
}

@include breakpoint (md) {
.resultPageBus {
  .resultPageBus__modalMobile .selectDropdown .popup {
    height: 100px;
    overflow: auto;
  }

  &__top__filter__left {
    .dropdown__menu {
      &__wrapper {
        overflow-y: unset;
      }
    }
  }
  .resultPageBus__bottom__content__orderSummary--mobile__content__items__item__left__body{
    .numOfBus{
      .selectDropdown{
        width: 60%;
      }
    }
  }

  .cardSlider {
    margin-left: -8px;
  }
  .modal__content {
    &__header {
      margin-bottom: 0px;
      width: unset;
      height: unset;

      button {
        width: unset;
        .icon-close {
          font-size: 24px;
          color: #999999
        }
      }
    }
  }
  .gridCard{
    display: grid;
    grid-template-columns: repeat(2, minmax(100px, 1fr));
    gap: 8px 8px;
  }

  .expandableList__card__channels__content__left__place-image {
    .thumbnail{
      width: 100%;
    }

    img {
      object-fit: contain;
    }
  }
}
}

@include breakpoint (xl) {
  .resultPageBus__modalMobile {
    .modal__content {
      width: 100%;
      height: 100%;
    }

    .selectDropdown .popup__background .item{
      padding: 0px;
    }

    .resultPageBus__bottom__content__orderSummary--mobile__content__items__item__left__body{
      .numOfBus{
        .selectDropdown{
          width: 60%;
        }
      }
    }

    .selectDropdown .popup{
      height: 150px;
      overflow: auto;
    }
  }
}

</style>
